import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Waypoint} from '@homeaway/react-unveil';
import Hit from '../../components/Hit';
import debounce from 'lodash.throttle';

class RecentActivityHit extends Component {
    constructor(props) {
        super(props);
        // set an artificially high initial state so that edap event doesn't fire until resize handler is done calculating
        this.state = {
            hitHeight: -5000
        };

        this.debounceWindowResize = debounce(this.handleWindowResize.bind(this), 100, {
            leading: true,
            trailing: true
        });
    }

    componentDidMount = () => {
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.debounceWindowResize);
            this.handleWindowResize();
        }
    }

    componentWillUnmount = () => {
        if (typeof window !== 'undefined') {
            window.removeEventListener('resize', this.debounceWindowResize);
        }
    }

    handleWindowResize = () => {
        const hitHeight = -this.waypointContainer.clientHeight;
        this.setState({hitHeight});
    }

    setContainer = (container) => {
        this.waypointContainer = container;
    }

    handleDelete = (event) => {
        const {
            handleDeletePropertyClick,
            hit,
            scratchpadId
        } = this.props;
        event.stopPropagation();
        handleDeletePropertyClick(hit.listingId, scratchpadId);
    }

    handleEnter = () => {
        const {onWaypointEnter, scratchpadId, index, hits} = this.props;

        onWaypointEnter(scratchpadId, index, hits);
    }

    render() {
        const {
            addedTime,
            changeSummary,
            hit,
            isDated,
            notifyChange,
            presentation,
            scratchpadId,
            recentActivityDetails
        } = this.props;

        return (
            <div className="scratchpad-app-hit-wrapper" ref={this.setContainer}>
                <Waypoint
                    key={scratchpadId}
                    label={scratchpadId}
                    onEnter={notifyChange ? this.handleEnter : () => {}}
                    threshold={this.state.hitHeight}
                >
                    <div className="text-muted small scratchpad-child-grid-hit-time">
                        {addedTime}
                    </div>
                    <Hit
                        {...hit}
                        {...presentation}
                        unit={hit && hit.unitUuid}
                        arrivalDate={recentActivityDetails && recentActivityDetails.startDate}
                        departureDate={recentActivityDetails && recentActivityDetails.endDate}
                        changeSummary={changeSummary}
                        notifyChange={notifyChange}
                        isDated={isDated}
                        gallery
                        showHeadline
                        onDelete={this.handleDelete}
                    />
                </Waypoint>
            </div>
        );
    }
}

RecentActivityHit.propTypes = {
    addedTime: PropTypes.string,
    endDate: PropTypes.string,
    hits: PropTypes.arrayOf(PropTypes.shape({})),
    index: PropTypes.number,
    notifyChange: PropTypes.bool,
    scratchpadId: PropTypes.string,
    startDate: PropTypes.string
};

export default RecentActivityHit;



// WEBPACK FOOTER //
// ./src/universal/recent-activity/components/recent-activity-hit.js